/* eslint-disable promise/param-names */
import Vue from 'vue'
import axios from 'axios'
import { GET_USER_DOCUMENTATION_ERROR, GET_USER_DOCUMENTATION_REQUEST, GET_USER_DOCUMENTATION_SUCCESS } from './actiontypes';
import documentationApi from '../../_services/api/documentation';

const state = {
  categories: {},
  status: '',
  errors: [],
  hasLoadedOnce: false,
};

const getters = {
  documentations: state => state.documentations,
};

const actions = {
  [GET_USER_DOCUMENTATION_REQUEST]: ({ commit, dispatch }, payload) => {
    return new Promise((resolve, reject) => {
      commit(GET_USER_DOCUMENTATION_REQUEST);
      documentationApi.getUserDocumentation()
        .then((response) => {
          if (response.success === true) {
            commit(GET_USER_DOCUMENTATION_SUCCESS, response.data);
            resolve(response);
          } else {
            commit(GET_USER_DOCUMENTATION_ERROR, response);
            reject(response.error);
          }
        })
        .catch((error) => {
          commit(GET_USER_DOCUMENTATION_ERROR, error);
          reject(error);
        });
    });
  },
};

const mutations = {
  [GET_USER_DOCUMENTATION_REQUEST]: (state) => {
    state.status = 'loading';
  },
  [GET_USER_DOCUMENTATION_SUCCESS]: (state, response) => {
    state.status = 'success';
    state.token = response.token;
    state.hasLoadedOnce = true;
    Vue.set(state, 'categories', response.categories);
  },
  [GET_USER_DOCUMENTATION_ERROR]: (state, response) => {
    state.status = 'error';
    state.hasLoadedOnce = true;
    Vue.set(state, 'errors', response.error);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
